import React, { useEffect, useState } from 'react';
import { GoogleMap, useJsApiLoader, Marker, Circle, OverlayView } from '@react-google-maps/api';
import { Row, Col, Button, Form } from 'react-bootstrap';
import getToken from '../../../hooks/getToken';
import ListaEmpresas from './ListaEmpresas';
import "../AcessoRestrito.css"
import axios from "axios";

const containerStyle = {
  width: '100%',
  height: '93vh',
  borderRadius: '8px'
};

function MyMapComponent({ validNameEmpresa, permissions, markers, center, setCenter, handleModalShowConfig, units, fixedCenter }) {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY
  });

  const initialRadius = 10000;
  const [map, setMap] = useState(null);
  const [radius, setRadius] = useState(initialRadius);
  const [zoom, setZoom] = useState(5);

  const [selected, setSelected] = useState([
    'P_0M5', 'P_0M3', 'P_0', 'P_0P5', 'P_0P75', 'P_1P', 'P_1P5'
  ]);

  const [showmMarkers, setShowmMarkers] = useState(markers);
  const [markersAround, setMarkersAround] = useState(null);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [all, setAll] = useState(false);

  const handleMarkerClick = async (marker) => {
    setAll(true);
    setSelectedMarker(marker);
    setCenter(marker);
    setZoom(interpolate(radius));
  };

  useEffect(() => {
    setSelected(prev =>
      validNameEmpresa
        ? [...prev, 'P_2P']
        : prev.filter(item => item !== 'P_2P')
    );
  }, [validNameEmpresa]);

  const onLoad = React.useCallback(function callback(map) {
    setMap(map);
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  function interpolate(x) {
    const data = [
      { x: 10000, y: 11.8 },
      { x: 20000, y: 11.0 },
      { x: 30000, y: 10.3 },
      { x: 40000, y: 10.0 },
      { x: 50000, y: 9.5 },
      { x: 60000, y: 9.3 },
      { x: 70000, y: 9.2 },
      { x: 80000, y: 9.0 },
      { x: 90000, y: 8.8 },
      { x: 100000, y: 8.7 }
    ];
    if (x <= data[0].x) return data[0].y;
    if (x >= data[data.length - 1].x) return data[data.length - 1].y;

    for (let i = 0; i < data.length - 1; i++) {
      if (x >= data[i].x && x <= data[i + 1].x) {
        const { x: x1, y: y1 } = data[i];
        const { x: x2, y: y2 } = data[i + 1];
        return Number((y1 + ((x - x1) * (y2 - y1)) / (x2 - x1)).toFixed(2));
      }
    }
  }

  const handleRadiusChange = (event) => {
    const value = Number(event.target.value);
    setRadius(value);
    setZoom(interpolate(value));
    format_makers();
  };

  const format_makers = (markers_around) => {
    let _markers = markers;

    if (selectedMarker) {
      if (markers_around) {
        _markers = [..._markers, ...markers_around];
      }
      let f_markers = _markers.filter(marker =>
        haversineDistance(center, marker) <= radius && selected.includes(marker.c)
      )
      setShowmMarkers(f_markers)
    } else {
      setShowmMarkers(_markers)
    }
  }

  const haversineDistance = (coords1, coords2) => {
    const toRad = (x) => (x * Math.PI) / 180;
    const R = 6371; // Raio da Terra em km
    const dLat = toRad(coords2.lat - coords1.lat);
    const dLng = toRad(coords2.lng - coords1.lng);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(coords1.lat)) * Math.cos(toRad(coords2.lat)) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c * 1000;
  };

  const getBackgroundColor = (category) => {
    switch (category) {
      case 'P_0M5':
        return '#febf97';
      case 'P_0M3':
        return '#f8f8d6';
      case 'P_0':
        return '#56c24b';
      case 'P_0P5':
        return '#b8faff';
      case 'P_0P75':
        return '#81d6f8';
      case 'P_1P':
        return '#8cb0b0';
      case 'P_1P5':
        return '#537979';
      case 'P_2P':
        return '#ed7615';
      default:
        return 'grey';
    }
  };

  const getMakersAround = async (_id) => {
    let l_ids = units.map(i => i._id);

    try {
      let { data } = await axios.post('/api/company/v1/location/around', {
        "id": _id,
        "r": 100,
        "l_ids": l_ids,
        "token": getToken()
      })

      let mks = data.map(item => {
        return {
          lat: parseFloat(item.location.lat),
          lng: parseFloat(item.location.lng),
          c: item.chart_p,
          m: item.chart_m,
          "i": item.include,
          "_id": item._id
        }
      })
      let f_markers = mks.filter(marker => marker.i !== true)
      setMarkersAround(f_markers);
    } catch (error) {
      setMarkersAround(null);
      console.log(error);
    }
  }

  useEffect(() => {
    format_makers();
  }, [markers, center, radius, selected]);

  useEffect(() => {
    if (selectedMarker !== null && selectedMarker._id) {
      getMakersAround(selectedMarker._id);
    }
  }, [selectedMarker]);

  useEffect(() => {
    if (selectedMarker === null) {

      setCenter(fixedCenter);
      setZoom(5);
    }
  }, [selectedMarker]);

  if (loadError) {
    return <div>Error loading maps</div>;
  }

  const darkThemeWithHighlight = [
    { elementType: "geometry", stylers: [{ color: "#1b2430" }] }, // Fundo grafite escuro
    { elementType: "labels.text.fill", stylers: [{ color: "#ffffff" }] }, // Texto branco para mais destaque
    { elementType: "labels.text.stroke", stylers: [{ color: "#141a24" }] }, // Contorno escuro para contraste
    { featureType: "road", elementType: "geometry", stylers: [{ color: "#2d3a4b" }] },
    { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#4a6572" }] }, // Rodovias azul acinzentado
    { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#3d5366" }] }, // Ruas secundárias mais visíveis
    { featureType: "poi", elementType: "geometry", stylers: [{ color: "#283445" }] },
    { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#1f3a34" }] }, // Verde mais vibrante nos parques
    { featureType: "water", elementType: "geometry", stylers: [{ color: "#0d3349" }] },
    { featureType: "administrative", elementType: "geometry", stylers: [{ color: "#788ba0" }] },
    { featureType: "landscape.man_made", elementType: "geometry", stylers: [{ color: "#36485a" }] },
  ];

  const mapOptions = {
    zoomControl: true,  // Mantém o controle de zoom
    streetViewControl: false,  // Remove o controle de Street View
    mapTypeControl: false,  // Remove o controle de tipo de mapa
    fullscreenControl: false,  // Remove o controle de tela cheia
    rotateControl: false,  // Remove o controle de rotação
    disableDefaultUI: true,  // Remove todos os controles padrão
    styles: darkThemeWithHighlight, // ⬅️ Ativa o modo escuro!
    gestureHandling: "greedy",  // ⬅️ Permite zoom com rolagem do mouse sem Ctrl
  };

  return isLoaded ? (
    <div>
      <Row className='g-2'>
        <Col xs={12} sm={12} md={3} lg={3} xl={2} xxl={2}
          className='p-3 rounded'
          style={{
            background: "linear-gradient(135deg, #2a2d30, #3a3d42)",
            color: "#f8f9fa",
            maxHeight: "93vh",
            boxShadow: "2px 0 10px rgba(0,0,0,0.2)",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div className='scroll scrollbar' style={{ flex: 1, overflowY: "auto" }}>
            <div style={{ width: '100%', overflow: 'auto', overflowX: 'hidden' }}>
              <ListaEmpresas
                setAll={setAll}
                companies={units}
                setSelectedMarker={setSelectedMarker}
                handleMarkerClick={handleMarkerClick}
              />
            </div>
          </div>
        </Col>

        <Col xs={12} sm={12} md={3} lg={3} xl={2} xxl={2}
          className='p-3 rounded'
          style={{
            background: "linear-gradient(135deg, #2a2d30, #3a3d42)",
            color: "#f8f9fa",
            maxHeight: "93vh",
            boxShadow: "2px 0 10px rgba(0,0,0,0.2)"
          }}
        >
          {all ?
            <div className='mb-3'>
              <h5 className='text-light'>
                Distância: <span style={{ color: "#ffcc70" }}>{radius / 1000} Km</span>
              </h5>
              <Form.Range
                min={10000}
                step={1000}
                max={100000}
                value={radius}
                onChange={handleRadiusChange}
                disabled={!permissions?.restricted?.write}
                style={{ accentColor: "#ffcc70" }}
              />
            </div>
            : null
          }

          <h5 className='text-light'>Minhas Unidades</h5>
          <div className='mb-3'>
            {['P_0M5', 'P_0M3', 'P_0', 'P_0P5', 'P_0P75', 'P_1P', 'P_1P5', ...(validNameEmpresa ? ['P_2P'] : [])].map((unit) => (
              <div key={unit} className="mb-1">
                <span style={{ color: "#e0e0e0" }}>
                  {unit} : <span style={{ color: "#ffcc70", fontWeight: "bold" }}>
                    {showmMarkers.filter(obj => obj.c === unit && obj.i === true).length}
                  </span> Usuários
                </span>
              </div>
            ))}
          </div>

          <h5 className='text-light'>Outras Unidades</h5>
          <div className='mb-3'>
            {['P_0M5', 'P_0M3', 'P_0', 'P_0P5', 'P_0P75', 'P_1P', 'P_1P5', ...(validNameEmpresa ? ['P_2P'] : [])].map((unit) => (
              <div key={unit} className="mb-1">
                <span style={{ color: "#e0e0e0" }}>
                  {unit} : <span style={{ color: "#ffcc70", fontWeight: "bold" }}>
                    {(
                      markersAround?.filter(marker =>
                        haversineDistance(center, marker) <= radius && selected.includes(marker.c)
                      ).filter(obj => obj.c === unit && obj.i === false).length || 0
                    )}
                  </span> Usuários
                </span>
              </div>
            ))}
          </div>

          {permissions?.restricted?.write && (
            <>
              <h5 className='text-light'>Escolha as Curvas</h5>
              <Button
                variant="secondary"
                className="mt-0 w-100"
                onClick={handleModalShowConfig}
                disabled={!permissions?.restricted?.write}
              >
                Selecione as Unidades
              </Button>
            </>
          )}
        </Col>

        <Col xs={12} sm={12} md={6} lg={6} xl={8} xxl={8}>
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={zoom}
            onLoad={onLoad}
            onUnmount={onUnmount}
            options={mapOptions}
          >

            {showmMarkers.filter(marker => selected.includes(marker.c) && marker.i === true)
              .map((marker, index) => (
                <div key={`${marker.lat}-${marker.lng}-${index}`}>
                  <Marker position={marker}
                    icon={{
                      url: '/img/ic_silo.png', // Substitua pela URL da sua imagem
                      scaledSize: new window.google.maps.Size(66, 66), // Define o tamanho do ícone
                    }}

                    onClick={() => handleMarkerClick(marker)}
                  />
                  <OverlayView
                    position={marker}
                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET} // Usar o overlay mouse target
                  >
                    <div style={{
                      position: 'absolute',
                      top: '-10px', // Ajuste conforme necessário para mover para cima
                      left: '-150px', // Ajuste conforme necessário para centralizar horizontalmente
                      width: 300,
                      height: '80px',
                      textAlign: 'center',
                    }}>
                      {
                        <span style={{
                          background: getBackgroundColor(marker.c),
                          fontSize: '14px',
                          border: '1px solid grey',
                          fontFamily: 'monospace',
                          fontWeight: 'bold',
                          color: 'black',
                          padding: '1px 8px',
                          borderRadius: 5
                        }}>
                          Recebendo:{(Number(marker?.pp) || 0) > 0 ? marker.pp : marker.c} Expedindo:{marker.m}
                        </span>
                      }
                    </div>
                  </OverlayView>
                </div>
              ))}

            {selectedMarker != null ? <Circle
              center={selectedMarker}
              radius={radius}
              options={{
                fillColor: 'blue',
                fillOpacity: 0.15,
                strokeColor: 'blue',
                strokeOpacity: 0.5,
                strokeWeight: 1,
              }}
            >
            </Circle> : null}
          </GoogleMap>
        </Col>
      </Row>
    </div>
  ) : null;
}

export default React.memo(MyMapComponent);
